/**
 * Like Button Module
 * Reużywalny komponent lajkowania z persystencją w localStorage.
 *
 * Użycie:
 *   <button class="like-btn" data-likes="303">
 *     <svg>...</svg>
 *     <span class="like-btn__count">303</span>
 *   </button>
 *
 * Wymagany atrybut data-card-id na rodzicu (np. <article data-card-id="...">).
 */

(function () {
    'use strict';

    // ============================================
    // SELECTORS
    // ============================================
    var SELECTORS = {
        btn: '.like-btn',
        count: '.like-btn__count',
        cardId: '[data-card-id]'
    };

    var CLASSES = {
        liked: 'is-liked',
        pulsing: 'is-pulsing'
    };

    var STORAGE_KEY = 'camel_feature_likes';

    // ============================================
    // INITIALIZATION
    // ============================================
    function init() {
        var likeButtons = document.querySelectorAll(SELECTORS.btn);

        if (!likeButtons.length) return;

        // Wczytaj zapisane polubienia z localStorage
        var savedLikes = getLikedCards();

        likeButtons.forEach(function (button) {
            var cardId = getCardId(button);
            var countElement = button.querySelector(SELECTORS.count);

            // Sprawdź czy karta była już polubiona
            if (savedLikes.includes(cardId)) {
                button.classList.add(CLASSES.liked);
            }

            // Event listener z stopPropagation (nie triggeruje flipa)
            button.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                handleLikeClick(button, cardId, countElement);
            });
        });
    }

    // ============================================
    // LIKE CLICK HANDLER
    // ============================================
    function handleLikeClick(button, cardId, countElement) {
        var savedLikes = getLikedCards();
        var isLiked = savedLikes.includes(cardId);

        if (isLiked) {
            // Usuń polubienie
            button.classList.remove(CLASSES.liked);
            removeLikedCard(cardId);

            if (countElement) {
                var currentCount = parseInt(countElement.textContent, 10) || 0;
                countElement.textContent = Math.max(0, currentCount - 1);
            }
        } else {
            // Dodaj polubienie
            button.classList.add(CLASSES.liked);
            saveLikedCard(cardId);

            // Animacja pulse
            button.classList.add(CLASSES.pulsing);
            button.addEventListener('animationend', function onPulseEnd() {
                button.classList.remove(CLASSES.pulsing);
                button.removeEventListener('animationend', onPulseEnd);
            });

            if (countElement) {
                var currentCount = parseInt(countElement.textContent, 10) || 0;
                countElement.textContent = currentCount + 1;
            }

            // Toast notification
            if (window.Toast) {
                Toast.show({
                    title: '+2 Punkty Camel!',
                    text: 'Brawo! Zdobywasz <strong>2 Punkty Camel</strong>!'
                });
            }
        }
    }

    // ============================================
    // CARD ID RESOLUTION
    // ============================================
    function getCardId(button) {
        // Szukaj data-card-id na najbliższym rodzicu
        var parent = button.closest(SELECTORS.cardId);
        if (parent && parent.dataset.cardId) {
            return parent.dataset.cardId;
        }

        // Fallback: użyj pathname + indeksu buttona
        var allButtons = document.querySelectorAll(SELECTORS.btn);
        var index = Array.from(allButtons).indexOf(button);
        var pageId = window.location.pathname.split('/').pop() || 'page';

        return pageId + '_like_' + index;
    }

    // ============================================
    // LOCAL STORAGE HELPERS
    // ============================================
    function getLikedCards() {
        try {
            var stored = localStorage.getItem(STORAGE_KEY);
            return stored ? JSON.parse(stored) : [];
        } catch (e) {
            return [];
        }
    }

    function saveLikedCard(cardId) {
        try {
            var likes = getLikedCards();
            if (!likes.includes(cardId)) {
                likes.push(cardId);
                localStorage.setItem(STORAGE_KEY, JSON.stringify(likes));
            }
        } catch (e) {
            // localStorage niedostępny
        }
    }

    function removeLikedCard(cardId) {
        try {
            var likes = getLikedCards();
            var index = likes.indexOf(cardId);
            if (index > -1) {
                likes.splice(index, 1);
                localStorage.setItem(STORAGE_KEY, JSON.stringify(likes));
            }
        } catch (e) {
            // localStorage niedostępny
        }
    }

    // ============================================
    // RUN
    // ============================================
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
